import http from "../plugins/http";
const baseUrl = "/box";

const initState = () => ({
  box: {
    id: "",
    description: "",
    height: "",
    width: "",
    length: "",
  },
});

const state = {
  box: initState().box,
  boxes: [],
  loadMore: true,
  isSearching: false,
  isLoading: false,
  isLoadingSearch: false,
  errors: {},
};

const mutations = {
  setIsLoading(state, value) {
    state.isLoading = value;
  },
  setAllBoxes(state, values) {
    state.boxes = values;
    state.loadMore = values.length === 20;
  },
  setMoreBoxes(state, values) {
    state.loadMore = values.length === 20;
    state.boxes = [...state.boxes, ...values];
  },
  setOneBox(state, value) {
    state.box = value;
  },
  setRemoveBox(state, id) {
    state.boxes = state.boxes.filter((box) => box.id !== id);
  },
  clearBoxValues(state) {
    state.errors = {};
    state.box = initState().box;
  },
  setErrors(state, value) {
    state.errors = value;
  },
};

const getters = {
  formatedBoxes(state) {
    return state.boxes.map(({ id, description, height, width, length }) => ({
      id: id,
      text: `${description} - A ${height}cm x L ${width}cm x C ${length}cm`,
    }));
  },
};

const actions = {
  async getAllBoxes({ commit }) {
    commit("setIsLoading", true);
    try {
      const { data } = await http.get(`${baseUrl}`);
      commit("setAllBoxes", data);
    } catch (err) {
      console.log(err);
    }
    commit("setIsLoading", false);
  },
  async getMoreAllBoxes({ commit }, page) {
    commit("setIsLoading", true);
    try {
      const url = `${baseUrl}?page=${page}`;
      const { data } = await http.get(url);
      commit("setMoreBoxes", data);
    } catch (err) {
      console.log(err);
    }
    commit("setIsLoading", false);
  },
  async getOneBox({ commit }, id) {
    try {
      const { data } = await http.get(`${baseUrl}/${id}`);
      commit("setOneBox", data);
    } catch (err) {
      console.log(err);
    }
  },
  async createBox({ commit }, values) {
    try {
      commit("setErrors", {});
      const { data } = await http.post(baseUrl, values);
      commit("setOneBox", data);
      commit(
        "setToastedSuccess",
        { message: "Caixa criada com sucesso" },
        { root: true }
      );
    } catch (err) {
      if (err.response.status == 406) {
        commit("setErrors", err.response.data.error);
      } else {
        commit(
          "setToastedError",
          { message: "Não foi póssivel criar caixa" },
          { root: true }
        );
      }
    }
  },
  async updateBox({ commit }, { id, ...values }) {
    try {
      commit("setErrors", {});
      const url = `${baseUrl}/${id}`;
      const { data } = await http.put(url, values);
      commit("setOneBox", data);
      commit(
        "setToastedSuccess",
        { message: "Caixa atualizada com sucesso" },
        { root: true }
      );
    } catch (err) {
      if (err.response.status == 406) {
        commit("setErrors", err.response.data.error);
      } else {
        commit(
          "setToastedError",
          { message: "Não foi póssivel atualizar caixa" },
          { root: true }
        );
      }
    }
  },
  async removeBox({ commit }, id) {
    try {
      const url = `${baseUrl}/${id}`;
      const { data } = await http.delete(url);
      commit("setRemoveBox", data.id);
      commit(
        "setToastedSuccess",
        { message: "Caixa removida com sucesso" },
        { root: true }
      );
    } catch (err) {
      commit(
        "setToastedError",
        { message: "Erro ao remover caixa" },
        { root: true }
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
